export {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogClose,
  type DialogProps,
  type DialogContentProps,
  type DialogTriggerProps,
} from '../../compositions/shared/Dialog';
